class SocialProofShorts extends HTMLElement {
  connectedCallback() {
    this.initWhenReady();
  }
  disconnectedCallback() {
    window.clearTimeout(this.swiperTimer);
    this.swiper?.destroy(true, true);
  }
  initWhenReady() {
    if (this.swiper) return;
    if (typeof window.Swiper === 'undefined') {
      this.swiperTimer = window.setTimeout(() => this.initWhenReady(), 50);
      return;
    }
    const slider = this.querySelector('.social-proof-shorts__slider');
    if (!slider) return;
    this.swiper = new window.Swiper(slider, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
            centerInsufficientSlides: true,
      navigation: {
        nextEl: this.querySelector('.social-proof-shorts__nav--next'),
        prevEl: this.querySelector('.social-proof-shorts__nav--prev'),
      },
      scrollbar: {
        el: this.querySelector('.social-proof-shorts__scrollbar'),
        draggable: true,
      },
      breakpoints: {
        550: { slidesPerView: 2.2, spaceBetween: 18 },
        750: { slidesPerView: 3.2, spaceBetween: 22 },
        990: { slidesPerView: 4, spaceBetween: 24 },
      },
    });

    this.swiper.on('slideChangeTransitionStart', () => {
      this.querySelectorAll('video').forEach((video) => video.pause());
    });
  }
}

if (!customElements.get('social-proof-shorts')) {
  customElements.define('social-proof-shorts', SocialProofShorts);
}
